import React from 'react';

export default function ProposalDetail({ proposal, onBack }) {
  return (
    <section className="max-w-3xl mx-auto px-4 py-10 bg-white rounded-lg shadow-md">
      <button
        onClick={onBack}
        className="text-sm mb-4 text-[#0f4b46] hover:underline flex items-center"
      >
        ← Volver a las propuestas
      </button>

      <div className="flex items-center gap-3 mb-3">
        <div className="text-5xl">{proposal.icon}</div>
        {proposal.img && <div className="h-60">
              <img 
                src={proposal.img}
                alt={proposal.title}
                className="w-full h-full object-cover rounded-xl shadow-md"
              />
            </div>}
        <div>
          <h2 className="text-2xl font-bold text-[#0f4b46]">{proposal.title}</h2>
          <p className="text-sm text-gray-500">{proposal.category}</p>
        </div>
      </div>

      <div className="border-t border-gray-200 pt-4">
        <p className="text-gray-700 leading-relaxed mb-6">
          {proposal.description ||
            `Esta propuesta busca beneficiar directamente a la comunidad de La Guardia, 
            fortaleciendo el desarrollo y mejorando la calidad de vida. 
            ${proposal.summary}`}
        </p>

        {/* <div className="flex items-center justify-between bg-gray-50 p-4 rounded-md">
          <div className="text-gray-800">
            <strong>Votos registrados:</strong> {proposal.votes}
          </div>
          <button
            className="bg-[#b71c1c] text-white text-sm px-4 py-2 rounded hover:bg-[#9a1a1a] transition-colors"
          >
            Votar por esta propuesta
          </button>
        </div> */}
      </div>
    </section>
  );
}
